module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAASBJREFUKBW9kj+rglAYxh+74dLkUjioKYF7i+iSS9BUHyNoERcdvV/E7yLikJ+iQUUoSCESG7Lre6AILndpuC+cP8/h97zveQ+He/SBD2LwgYdZuO12+xBF8eUvyxLvuus6nE4nTCaTF1NVFQYEOY6D0WgE13WZKQgCzOdzmKYJ3/ehqip2ux1jPM+DIAj4ms1m34qiYDweo65rRFHEsvM8Dxp5nmO/30OSJMacz2ckSYJh27ag0hS0f9d0drvd0DTNL2bQV4RhGEjTFJZlgfRqtcL1esX9fsdyuYSu6+zqxCwWC0ynU3C2bT80TYMsy1QAh8OB9cREP9HjZFkGaocSFUWB4/GIYW9EHMcIw/DJ/rleLhes12tsNhtw//4BfgA3qn2WRjBoaQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/muebles-tv.png
// module id = 512
// module chunks = 0